import { Component, Input } from '@angular/core';

export interface HighLight {
  url: string;
  title: string;
  childs: Array<{ title: string; link: string; }>;
  buttonDescription: string;
}

@Component({
  selector: 'fcp-highlight',
  templateUrl: './highlight.component.html',
  styleUrls: ['./highlight.component.scss']
})
export class HighlightComponent {
  @Input() public highlight: HighLight;

}
